import { useGetAsset } from 'features/assetControl/hooks/useGetAsset';
import { useParams } from 'react-router-dom';

export function AssetBreadcrumb() {
  const { unitExternalIdentifier = '' } = useParams();
  const { asset } = useGetAsset(unitExternalIdentifier);

  return asset ? `${asset.externalIdentifier} | ${asset.name}` : unitExternalIdentifier;
}
